import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-authority-restriction-modal',
  templateUrl: './authority-restriction-modal.component.html',
  styleUrls: ['./authority-restriction-modal.component.scss'],
  standalone: false,
})
export class AuthorityRestrictionModalComponent {
  @Input() public isSinglePassenger: boolean = true;

  constructor(public modal: NgbActiveModal) {}

  get titleKey(): string {
    return 'authorityRestriction.title';
  }

  get bodyKey(): string {
    return this.isSinglePassenger
      ? 'authorityRestriction.bodySingle'
      : 'authorityRestriction.bodyMultiple';
  }

  onClose(): void {
    this.modal.close({ isSinglePassenger: this.isSinglePassenger });
  }
}
